import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { BookHeart, Loader2, Sparkles } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Book2Teaser() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [joined, setJoined] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${API}/book2-waitlist`, { email: email.trim() });
      setJoined(true);
      toast.success("You're on the Book 2 early-notification list! ✨");
      if (typeof window.gtag === "function") {
        window.gtag("event", "book2_waitlist_signup", { method: "homepage_teaser" });
      }
    } catch (err) {
      if (err?.response?.status === 409) {
        setJoined(true);
        toast("You're already on the Book 2 list — thank you!");
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="book2"
      className="relative z-10 bg-twilight py-24 md:py-32"
      data-testid="book2-teaser-section"
    >
      <div className="mx-auto max-w-4xl px-6 md:px-12">
        <div className="relative overflow-hidden rounded-3xl border border-gold/25 bg-gradient-to-br from-twilight-surface via-twilight to-twilight-surface p-8 md:p-14">
          {/* decorative stars */}
          <div className="pointer-events-none absolute -top-10 -right-10 h-40 w-40 rounded-full bg-gold/10 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-16 -left-8 h-52 w-52 rounded-full bg-gold/5 blur-3xl" />

          <div className="relative">
            <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-gold/40 bg-gold/10 px-4 py-1.5 font-body text-xs uppercase tracking-[0.25em] text-gold">
              <Sparkles className="h-3.5 w-3.5" />
              Coming Next in the Hannah Series
            </div>

            <h2 className="font-display text-4xl font-bold leading-tight text-cream sm:text-5xl md:text-6xl">
              Hannah's Heavenly Father
            </h2>
            <p className="mt-2 font-display text-xl italic text-gold md:text-2xl">
              A Father's Day Story
            </p>

            <p className="mt-6 max-w-2xl font-body text-base leading-relaxed text-slate-300 md:text-lg">
              When Hannah's school hosts <em className="not-italic text-cream">"Doughnuts with
              Fathers,"</em> she wonders where she'll fit in. What she discovers is a love that
              fills every empty seat — and a Father who was there all along.
            </p>

            <p className="mt-5 max-w-2xl font-body text-sm text-slate-400">
              Cover reveal and release date coming soon. Be the first to know when
              <em className="not-italic text-cream"> Hannah's Heavenly Father</em> is available.
            </p>

            {!joined ? (
              <form
                onSubmit={submit}
                className="mt-8 flex flex-col gap-3 sm:flex-row sm:max-w-md"
                data-testid="book2-form"
              >
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  data-testid="book2-email-input"
                  className="flex-1 rounded-full border border-white/15 bg-white/5 px-5 py-3 text-cream placeholder:text-slate-500 outline-none transition-[border-color] duration-300 focus:border-gold"
                />
                <button
                  type="submit"
                  disabled={loading}
                  data-testid="book2-submit-button"
                  className="inline-flex items-center justify-center gap-2 rounded-full bg-gold px-6 py-3 font-medium text-twilight transition-[background-color,box-shadow] duration-300 hover:bg-gold-light hover:shadow-[0_0_25px_rgba(251,191,36,0.55)] disabled:opacity-60"
                >
                  {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <BookHeart className="h-4 w-4" />}
                  Notify Me
                </button>
              </form>
            ) : (
              <div
                className="mt-8 inline-flex items-center gap-3 rounded-2xl border border-gold/30 bg-gold/10 px-5 py-4 font-body text-sm text-cream"
                data-testid="book2-joined-state"
              >
                <BookHeart className="h-5 w-5 text-gold" />
                You're on the list — I'll email you the moment Book 2 has a cover and a date. 💛
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
